export default __webpack_public_path__ + "static/media/dropdown.768dc702.svg";